import React from 'react'
import './About.scss'

function Index() {
    return (
        <div className='mt-20 lg:mt-40 mb-20 flex flex-col center'>
            <div className='w-full center flex flex-col '>

                <div className="grid grid-cols-12 lg:gap-10 w-[80%] bg-orange-gradient-about p-10  ">
                    <div className="col-span-12 lg:col-span-6 flex flex-col h-full justify-center">
                        <h1 className='text-white mt-5 lg:mt-0 text-4xl tex-regular lg:pl-5'>Rreth Nesh</h1>
                        <p className='text-white opacity-80 text-sm montserrat mt-10 lg:mt-4 lg:pl-10'>
                            "HIT PETROL" Sh.p.k eshte themeluar ne vitin 1992 ne Kosove, duke u fokusuar ne shitjen dhe shperndarjen e derivateve te naftes, kryesisht nafte dhe bitum - produkte kryesore per zhvillimin e infrastruktures.
                            Me nje perkushtim ndaj cilesise dhe besueshmerise, kompania u be nje partner strategjik i madh
                            projekte infrastrukturore, duke kontribuar pozitivisht ne ecurine e vendit.
                        </p>
                        <br />
                        <p className='text-white opacity-80 text-sm montserrat lg:pl-10'>
                            Pas me shume se dy dekadave sukses, ne vitin 2013,
                            "HIT PETROL" Sh.p.k zgjeroi veprimtarine e saj duke krijuar HIT IMPERIAL, nje dege e dedikuar per ndertimin e objekteve tregtare dhe banesore. Me nje fokus te forte ne inovacionin dhe cilesine,
                            HIT IMPERIAL zhvilloi komplekse moderne rezidenciale dhe qendra tregtare, duke perdorur teknologji te avancuar dhe materiale te standardit te larte.
                        </p>

                        <a href="/vizualizimete" className="px-[20px] lg:ml-5 w-fit py-[5px] text-lg bg-[#ad2f1e] tex-regular font-light text-white mt-5">
                            shiko projektet
                        </a>
                    </div>
                    <div className="col-span-12 mt-5 lg:mt-0 lg:col-span-6">
                        <img src="/images/branding/1-05.jpg" loading="lazy" className='w-full h-auto' alt="" />
                    </div>
                </div>
                <br />

                <div className="w-full flex flex-col items-end mt-10 lg:mt-20">
                    <div className='w-[100%]'>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-12 lg:col-span-5 "></div>
                            <div className="col-span-1 flex justify-end h-full">
                                <div className="none lg:flex h-full flex-col center w-fit m-0 p-0">
                                    <div className='w-[10px] hidden lg:block h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block w-[2px] main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-11 lg:col-span-6 relative">
                                <div className="absolute w-full h-[1px] hidden lg:block main-red-bg bottom-[-5px] left-[-1px]"></div>
                                <div className="flex w-full flex-col items-end h-full">
                                    <div className='flex w-full justify-end h-full'>
                                        <div className="flex flex-col w-[50%] relative items-end">
                                            <h1 className='main-red-color mt-20 lg:mt-0 text-5xl lg:text-7xl text-end tex-regular '>2024 <p className="montserrat inline">-</p> 2026</h1>
                                        </div>
                                        <div className="flex flex-col w-[50%] items-end ml-5 relative">
                                            <img src="images/about/1/1.1.webp" loading="lazy" className='object-cover w-full rounded-md' alt="" />
                                            <img src="images/about/1/2.webp" loading="lazy" className='object-cover mt-1 w-full rounded-md' alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-11 lg:col-span-5 relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-5px] right-0 "></div>
                                <div className="flex w-full flex-col">
                                    <div className='flex w-full'>
                                        <div className="flex flex-col w-[60%] items-end relative">
                                            <img src="images/about/2/1.webp" loading="lazy" className='object-cover w-full rounded-md' alt="" />
                                            <img src="images/about/2/2.webp" loading="lazy" className='object-cover w-full rounded-md mt-1' alt="" />
                                        </div>
                                        <div className="flex flex-col w-[40%] ml-5">
                                            <h1 className='text-white text-5xl mt-20 lg:mt-0 lg:text-6xl tex-regular '>2023 <p className="montserrat inline">-</p> 2025</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-1 flex justify-end h-full relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-5px] right-0 "></div>
                                <div className="flex h-full flex-col center w-fit">
                                    <div className='w-[10px] hidden lg:block h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block w-[2px] main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-12 lg:col-span-5 flex flex-col h-full"></div>
                        </div>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-12 lg:col-span-5 flex justify-end "></div>
                            <div className="col-span-1 flex justify-end h-full">
                                <div className="flex h-full flex-col center w-fit">
                                    <div className='w-[10px] hidden lg:block h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block  w-[2px] mt main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-11 lg:col-span-6 relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-4px] left-[-5px] "></div>
                                <div className="flex w-full flex-col items-end">
                                    <div className='flex w-full justify-end'>
                                        <div className="flex flex-col w-[50%] items-end">
                                            <h1 className='main-red-color mt-20 lg:mt-0 text-5xl lg:text-7xl tex-regular text-end '>2018 <p className="montserrat inline">-</p> 2021</h1>
                                        </div>
                                        <div className="flex flex-col w-[50%] items-end ml-5 relative">
                                            <img src="images/about/3/1 copy.webp" loading="lazy" className='object-cover w-full rounded-md' alt="" />
                                            <img src="images/about/3/2 copy.webp" loading="lazy" className='object-cover w-full rounded-md mt-1' alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-11 lg:col-span-5 relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-5px] right-0 "></div>
                                <div className="flex w-full flex-col">
                                    <div className='flex w-full'>
                                        <div className="flex flex-col w-[60%] items-end relative">
                                            <img src="images/about/4/1 copy.webp" loading="lazy" className='w-full object-cover rounded-md' alt="" />
                                            <img src="images/about/4/2 copy.webp" loading="lazy" className='w-full object-cover rounded-md mt-1' alt="" />
                                        </div>
                                        <div className="flex flex-col w-[40%] ml-5">
                                            <h1 className='text-white text-5xl mt-20 lg:mt-0 lg:text-6xl tex-regular '>2017 <p className="montserrat inline">-</p> 2019</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-1 flex justify-end h-full relative">
                                <div className="absolute w-full hidden lg:block  h-[1px] main-red-bg bottom-[-5px] right-0 "></div>
                                <div className="flex h-full flex-col center w-fit">
                                    <div className='w-[10px] hidden lg:block h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block w-[2px] main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-12 lg:col-span-5 flex flex-col h-full"></div>
                        </div>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-12 lg:col-span-5 flex justify-end"></div>
                            <div className="col-span-1 flex justify-end h-full">
                                <div className="flex h-full flex-col center w-fit ">
                                    <div className='w-[10px] hidden lg:block  h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block  w-[2px] main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-11 lg:col-span-6 relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-5px] left-[px] "></div>
                                <div className="flex w-full flex-col items-end">
                                    <div className='flex w-full justify-end'>
                                        <div className="flex flex-col w-[40%] items-end">
                                            <h1 className='main-red-color mt-20 lg:mt-0 text-5xl lg:text-6xl tex-regular text-end '>2014 <p className="montserrat inline">-</p> 2016</h1>
                                        </div>
                                        <div className="flex flex-col w-[50%] items-end ml-5 relative">
                                            <img src="images/about/5/1.webp" loading="lazy" className='object-cover w-full  rounded-md' alt="" />
                                            <img src="images/about/5/2.webp" loading="lazy" className='object-cover w-full rounded-md mt-1' alt="" />
                                            {/* <img src="images/about/5/3.webp" loading="lazy" className='object-cover w-full rounded-md mt-1' alt="" /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full grid grid-cols-12">
                            <div className="col-span-11 lg:col-span-5 relative">
                                <div className="absolute w-full hidden lg:block h-[1px] main-red-bg bottom-[-5px] right-0 "></div>
                                <div className="flex w-full flex-col">
                                    <div className='flex w-full'>
                                        <div className="flex flex-col w-[60%] items-end relative">
                                            <img src="images/about/6/1.webp" loading="lazy" className='object-cover w-full rounded-md' alt="" />
                                            <img src="images/about/6/2.webp" loading="lazy" className='object-cover w-full rounded-md mt-1' alt="" />
                                        </div>
                                        <div className="flex flex-col w-[40%] ml-5">
                                            <h1 className='text-white text-5xl mt-20 lg:mt-0 lg:text-6xl tex-regular '>2013 <p className="montserrat inline">-</p> 2014</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-1 flex justify-end h-full relative">
                                <div className="absolute w-full hidden lg:block  h-[1px] main-red-bg bottom-[-5px] right-[3px] "></div>
                                <div className="flex h-[101%] flex-col center w-fit">
                                    <div className='w-[10px] hidden lg:block relative top-[-0px] h-[10px] rounded-full main-red-bg'></div>
                                    <div className='h-[100%] hidden lg:block w-[2px] relative top-[-2px] left-[0.5px] main-red-bg'></div>
                                </div>
                            </div>
                            <div className="col-span-12 lg:col-span-5 flex flex-col h-full"></div>
                        </div>
                    </div>
                </div>

                <br />
                <div className="w-[80%] mt-40 bg-[#192929]">
                    <div className="w-full grid grid-cols-12 ">
                        <div className="col-span-12 lg:col-span-6 flex center">
                            <video className='w-[100%]' loop muted autoPlay>
                                <source src='videos/lokacioni_3.mp4' type='video/mp4' />
                            </video>
                        </div>
                        <div className="col-span-12 lg:col-span-6 order-1 lg:order-2 py-10 center lg:px-10 lg:py-10 lg:p-0 h-full flex lg:justify-center lg:items-centerr">
                            <h1 className='tex-regular text-white text-4xl md:text-5xl lg:text-6xl py-10 lg:py-0 w-fit lg:pl-5'>
                                NA VIZITO NE <br />
                                <b className='main-red-color'>ZYRET</b> <br />TONA
                            </h1>
                        </div>
                    </div>
                </div>

                <img className='mb-5 mt-5 w-[80%]' loading="lazy" src="/images/body/map.png" alt="" />

                <a href="https://maps.app.goo.gl/t2yuhAZyxGEYeEbk8?g_st=aw" className="tex-regular mt-5  bg-[#ec3921cb] py-3 px-3 lg:px-10 text-white text-xs lg:text-base">
                    MAPS
                </a>
            </div>
        </div>
    )
}

export default Index
